import React, { useState, useRef, useEffect } from 'react';
import {
  DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger,
} from './ui/dropdown-menu';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from './ui/dialog';
import { Button } from './ui/button';
import { Share2, Link2, Download, Instagram, Loader2, Copy } from 'lucide-react';
import { getGameName, getGameColor } from '../constants/theme';
import { useAuth } from '../contexts/AuthContext';
import { toast } from 'sonner';

const API = process.env.REACT_APP_BACKEND_URL;

const LAYOUTS = [
  { id: 'classic', name: 'Classique' },
  { id: 'card', name: 'Carte' },
  { id: 'band', name: 'Bandeau' },
  { id: 'minimal', name: 'Minimal' },
  { id: 'neon', name: 'Néon' },
];

const brandSvg = {
  whatsapp: <svg viewBox="0 0 24 24" className="w-4 h-4 fill-[#25D366]"><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z"/></svg>,
  facebook: <svg viewBox="0 0 24 24" className="w-4 h-4 fill-[#1877F2]"><path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/></svg>,
  discord: <svg viewBox="0 0 24 24" className="w-4 h-4 fill-[#5865F2]"><path d="M20.317 4.3698a19.7913 19.7913 0 00-4.8851-1.5152.0741.0741 0 00-.0785.0371c-.211.3753-.4447.8648-.6083 1.2495-1.8447-.2762-3.68-.2762-5.4868 0-.1636-.3933-.4058-.8742-.6177-1.2495a.077.077 0 00-.0785-.037 19.7363 19.7363 0 00-4.8852 1.515.0699.0699 0 00-.0321.0277C.5334 9.0458-.319 13.5799.0992 18.0578a.0824.0824 0 00.0312.0561c2.0528 1.5076 4.0413 2.4228 5.9929 3.0294a.0777.0777 0 00.0842-.0276c.4616-.6304.8731-1.2952 1.226-1.9942a.076.076 0 00-.0416-.1057c-.6528-.2476-1.2743-.5495-1.8722-.8923a.077.077 0 01-.0076-.1277c.1258-.0943.2517-.1923.3718-.2914a.0743.0743 0 01.0776-.0105c3.9278 1.7933 8.18 1.7933 12.0614 0a.0739.0739 0 01.0785.0095c.1202.099.246.1981.3728.2924a.077.077 0 01-.0066.1276 12.2986 12.2986 0 01-1.873.8914.0766.0766 0 00-.0407.1067c.3604.698.7719 1.3628 1.225 1.9932a.076.076 0 00.0842.0286c1.961-.6067 3.9495-1.5219 6.0023-3.0294a.077.077 0 00.0313-.0552c.5004-5.177-.8382-9.6739-3.5485-13.6604a.061.061 0 00-.0312-.0286zM8.02 15.3312c-1.1825 0-2.1569-1.0857-2.1569-2.419 0-1.3332.9555-2.4189 2.157-2.4189 1.2108 0 2.1757 1.0952 2.1568 2.419 0 1.3332-.9555 2.4189-2.1569 2.4189zm7.9748 0c-1.1825 0-2.1569-1.0857-2.1569-2.419 0-1.3332.9554-2.4189 2.1569-2.4189 1.2108 0 2.1757 1.0952 2.1568 2.419 0 1.3332-.946 2.4189-2.1568 2.4189Z"/></svg>,
};

export default function ShareEvent({ t, triggerClassName = '', iconOnly = true }) {
  const { user } = useAuth();
  const [storyOpen, setStoryOpen] = useState(false);
  const [generating, setGenerating] = useState(false);
  const [variants, setVariants] = useState([]); // [{id, name, url, blob}]
  const [selected, setSelected] = useState(0);

  const shareUrl = `${API}/api/share/tournament/${t.id}`;
  const directUrl = `${window.location.origin}/e/tournament/${t.id}`;
  const formatDate = (d) => !d ? '' : new Date(d).toLocaleDateString('fr-FR', {
    weekday: 'long', day: 'numeric', month: 'long', hour: '2-digit', minute: '2-digit',
  });
  const shareText = `${t.name} — ${getGameName(t.game)}${t.format ? ` (${t.format})` : ''}${t.date ? ` le ${formatDate(t.date)}` : ''}. Inscriptions : ${shareUrl}`;

  const loadImg = (src) => new Promise((resolve) => {
    if (!src) return resolve(null);
    const img = new Image();
    img.crossOrigin = 'anonymous';
    img.onload = () => resolve(img);
    img.onerror = () => resolve(null);
    img.src = src.startsWith('http') ? src : `${API}${src.startsWith('/') ? '' : '/'}${src}`;
  });

  const wrapText = (ctx, text, maxWidth) => {
    const words = (text || '').split(' ');
    const lines = [];
    let line = '';
    for (const w of words) {
      const test = line ? `${line} ${w}` : w;
      if (ctx.measureText(test).width > maxWidth && line) { lines.push(line); line = w; }
      else line = test;
    }
    if (line) lines.push(line);
    return lines;
  };

  const roundRect = (ctx, x, y, w, h, r) => {
    if (ctx.roundRect) { ctx.beginPath(); ctx.roundRect(x, y, w, h, r); return; }
    ctx.beginPath();
    ctx.moveTo(x + r, y);
    ctx.arcTo(x + w, y, x + w, y + h, r);
    ctx.arcTo(x + w, y + h, x, y + h, r);
    ctx.arcTo(x, y + h, x, y, r);
    ctx.arcTo(x, y, x + w, y, r);
    ctx.closePath();
  };

  // draw image "cover" (fill box, crop overflow)
  const drawCover = (ctx, img, x, y, w, h) => {
    const scale = Math.max(w / img.width, h / img.height);
    const dw = img.width * scale, dh = img.height * scale;
    ctx.drawImage(img, x + (w - dw) / 2, y + (h - dh) / 2, dw, dh);
  };
  // draw image "contain" (whole image visible inside box)
  const drawContain = (ctx, img, x, y, w, h) => {
    const scale = Math.min(w / img.width, h / img.height);
    const dw = img.width * scale, dh = img.height * scale;
    const dx = x + (w - dw) / 2, dy = y + (h - dh) / 2;
    ctx.drawImage(img, dx, dy, dw, dh);
    return { dx, dy, dw, dh };
  };

  // blurred, enlarged cover as full background + dark overlay
  const drawBlurBg = (ctx, img, W, H, overlay = 0.45, gameColor = '#111') => {
    if (img) {
      ctx.save();
      ctx.filter = 'blur(46px) brightness(0.75)';
      // scale up a bit more so blur edges don't show
      const scale = Math.max(W / img.width, H / img.height) * 1.25;
      const dw = img.width * scale, dh = img.height * scale;
      ctx.drawImage(img, (W - dw) / 2, (H - dh) / 2, dw, dh);
      ctx.restore();
    } else {
      const g = ctx.createLinearGradient(0, 0, W, H);
      g.addColorStop(0, gameColor); g.addColorStop(1, '#0a0a0a');
      ctx.fillStyle = g; ctx.fillRect(0, 0, W, H);
    }
    ctx.fillStyle = `rgba(8,8,10,${overlay})`;
    ctx.fillRect(0, 0, W, H);
  };

  const drawLogo = (ctx, logo, cx, cy, size, ring = '#fff') => {
    if (!logo) return;
    ctx.save();
    ctx.beginPath(); ctx.arc(cx, cy, size / 2, 0, Math.PI * 2); ctx.closePath();
    ctx.fillStyle = '#0a0a0a'; ctx.fill();
    ctx.clip();
    drawCover(ctx, logo, cx - size / 2, cy - size / 2, size, size);
    ctx.restore();
    ctx.save();
    ctx.strokeStyle = ring; ctx.lineWidth = 6;
    ctx.beginPath(); ctx.arc(cx, cy, size / 2, 0, Math.PI * 2); ctx.stroke();
    ctx.restore();
  };

  const renderLayout = async (layoutId, cover, logo) => {
    const W = 1080, H = 1920;
    const canvas = document.createElement('canvas');
    canvas.width = W; canvas.height = H;
    const ctx = canvas.getContext('2d');
    const accent = getGameColor(t.game) || '#FF6B35';
    const title = t.name || 'Tournoi';
    const salle = t.venue?.name || t.venue?.city || '';
    const dateStr = formatDate(t.date);
    const shopName = user?.company_name || t.organizer_pseudo || t.shop_name || '';
    ctx.textBaseline = 'alphabetic';

    if (layoutId === 'classic') {
      drawBlurBg(ctx, cover, W, H, 0.35, accent);
      // sharp cover in upper region
      if (cover) drawContain(ctx, cover, 40, 90, W - 80, H * 0.60);
      // bottom gradient
      const g = ctx.createLinearGradient(0, H * 0.55, 0, H);
      g.addColorStop(0, 'rgba(8,8,10,0)'); g.addColorStop(0.4, 'rgba(8,8,10,0.85)'); g.addColorStop(1, 'rgba(8,8,10,0.98)');
      ctx.fillStyle = g; ctx.fillRect(0, H * 0.55, W, H * 0.45);
      // shop logo + name
      let y = H - 470;
      if (logo) { drawLogo(ctx, logo, 60 + 55, y + 55, 110, accent); }
      ctx.fillStyle = '#fff'; ctx.font = 'bold 44px Arial, sans-serif';
      if (shopName) ctx.fillText(shopName.toUpperCase(), logo ? 200 : 60, y + 72);
      // accent bar
      y += 150;
      ctx.fillStyle = accent; ctx.fillRect(60, y, 90, 10); y += 60;
      // title
      ctx.fillStyle = '#fff'; ctx.font = 'bold 78px Arial, sans-serif';
      for (const ln of wrapText(ctx, title, W - 120).slice(0, 3)) { ctx.fillText(ln, 60, y); y += 90; }
      y += 20;
      ctx.fillStyle = accent; ctx.font = 'bold 46px Arial, sans-serif';
      if (dateStr) { ctx.fillText(dateStr, 60, y); y += 66; }
      ctx.fillStyle = '#cfcfd4'; ctx.font = '44px Arial, sans-serif';
      if (salle) ctx.fillText(salle, 60, y);
    }

    else if (layoutId === 'card') {
      drawBlurBg(ctx, cover, W, H, 0.5, accent);
      // sharp cover as rounded card centered upper
      const boxX = 90, boxY = 150, boxW = W - 180, boxH = H * 0.50;
      ctx.save();
      roundRect(ctx, boxX, boxY, boxW, boxH, 40);
      ctx.shadowColor = 'rgba(0,0,0,0.6)'; ctx.shadowBlur = 60; ctx.shadowOffsetY = 20;
      ctx.fillStyle = '#0a0a0a'; ctx.fill();
      ctx.restore();
      ctx.save(); roundRect(ctx, boxX, boxY, boxW, boxH, 40); ctx.clip();
      if (cover) drawCover(ctx, cover, boxX, boxY, boxW, boxH);
      ctx.restore();
      // glass info panel bottom
      const pX = 70, pW = W - 140, pY = H * 0.66, pH = H * 0.28;
      ctx.save();
      roundRect(ctx, pX, pY, pW, pH, 44);
      ctx.fillStyle = 'rgba(18,18,22,0.72)'; ctx.fill();
      ctx.strokeStyle = 'rgba(255,255,255,0.15)'; ctx.lineWidth = 2; ctx.stroke();
      ctx.restore();
      let tx = pX + 60;
      let y = pY + 90;
      if (logo) { drawLogo(ctx, logo, tx + 50, y - 10, 100, accent); tx += 130; }
      ctx.fillStyle = accent; ctx.font = 'bold 40px Arial, sans-serif';
      if (shopName) ctx.fillText(shopName.toUpperCase(), tx, y);
      y += 80;
      ctx.fillStyle = '#fff'; ctx.font = 'bold 66px Arial, sans-serif';
      for (const ln of wrapText(ctx, title, pW - 120).slice(0, 2)) { ctx.fillText(ln, pX + 60, y); y += 76; }
      y += 14;
      ctx.fillStyle = '#e6e6ea'; ctx.font = '42px Arial, sans-serif';
      if (dateStr) { ctx.fillText(dateStr, pX + 60, y); y += 58; }
      if (salle) { ctx.fillStyle = '#b9b9c0'; ctx.fillText(`📍 ${salle}`, pX + 60, y); }
    }

    else if (layoutId === 'band') {
      drawBlurBg(ctx, cover, W, H, 0.3, accent);
      const seam = H * 0.60;
      if (cover) drawContain(ctx, cover, 40, 70, W - 80, seam - 90);
      // solid accent band bottom
      ctx.fillStyle = accent; ctx.fillRect(0, seam, W, H - seam);
      // subtle darken bottom of band for contrast
      const g = ctx.createLinearGradient(0, seam, 0, H);
      g.addColorStop(0, 'rgba(0,0,0,0.12)'); g.addColorStop(1, 'rgba(0,0,0,0.35)');
      ctx.fillStyle = g; ctx.fillRect(0, seam, W, H - seam);
      // logo overlapping seam (left)
      if (logo) drawLogo(ctx, logo, 150, seam, 150, '#fff');
      let y = seam + 130;
      const tx = 60;
      ctx.fillStyle = 'rgba(0,0,0,0.85)'; ctx.font = 'bold 42px Arial, sans-serif';
      if (shopName) { ctx.fillText(shopName.toUpperCase(), logo ? 250 : tx, seam + 12); }
      ctx.fillStyle = '#ffffff'; ctx.font = 'bold 80px Arial, sans-serif';
      for (const ln of wrapText(ctx, title, W - 120).slice(0, 3)) { ctx.fillText(ln, tx, y); y += 92; }
      y += 24;
      ctx.fillStyle = 'rgba(0,0,0,0.85)'; ctx.font = 'bold 48px Arial, sans-serif';
      if (dateStr) { ctx.fillText(dateStr, tx, y); y += 66; }
      ctx.font = '46px Arial, sans-serif';
      if (salle) ctx.fillText(salle, tx, y);
    }

    else if (layoutId === 'minimal') {
      drawBlurBg(ctx, cover, W, H, 0.6, accent);
      // top: logo + shop name centered
      let topY = 150;
      if (logo) { drawLogo(ctx, logo, W / 2, topY, 130, accent); topY += 110; }
      ctx.textAlign = 'center';
      ctx.fillStyle = '#fff'; ctx.font = 'bold 40px Arial, sans-serif';
      if (shopName) ctx.fillText(shopName.toUpperCase(), W / 2, topY);
      // sharp cover centered
      if (cover) drawContain(ctx, cover, 120, 380, W - 240, H * 0.42);
      // bottom centered info
      let y = H - 360;
      ctx.fillStyle = accent; ctx.fillRect(W / 2 - 50, y - 60, 100, 8);
      ctx.fillStyle = '#fff'; ctx.font = 'bold 76px Arial, sans-serif';
      for (const ln of wrapText(ctx, title, W - 160).slice(0, 3)) { ctx.fillText(ln, W / 2, y); y += 88; }
      y += 20;
      ctx.fillStyle = accent; ctx.font = 'bold 46px Arial, sans-serif';
      if (dateStr) { ctx.fillText(dateStr, W / 2, y); y += 64; }
      ctx.fillStyle = '#d5d5da'; ctx.font = '44px Arial, sans-serif';
      if (salle) ctx.fillText(salle, W / 2, y);
      ctx.textAlign = 'left';
    }

    else if (layoutId === 'neon') {
      drawBlurBg(ctx, cover, W, H, 0.62, accent);
      // corner accents
      ctx.save();
      ctx.strokeStyle = accent; ctx.lineWidth = 12; ctx.lineCap = 'round';
      ctx.beginPath(); ctx.moveTo(60, 140); ctx.lineTo(60, 60); ctx.lineTo(140, 60); ctx.stroke();
      ctx.beginPath(); ctx.moveTo(W - 140, H - 60); ctx.lineTo(W - 60, H - 60); ctx.lineTo(W - 60, H - 140); ctx.stroke();
      ctx.restore();
      // sharp cover framed card upper-center
      const boxX = 110, boxY = 220, boxW = W - 220, boxH = H * 0.46;
      ctx.save(); roundRect(ctx, boxX, boxY, boxW, boxH, 28); ctx.clip();
      ctx.fillStyle = '#0a0a0a'; ctx.fillRect(boxX, boxY, boxW, boxH);
      if (cover) drawCover(ctx, cover, boxX, boxY, boxW, boxH);
      ctx.restore();
      ctx.save();
      ctx.strokeStyle = accent; ctx.lineWidth = 8; ctx.shadowColor = accent; ctx.shadowBlur = 40;
      roundRect(ctx, boxX, boxY, boxW, boxH, 28); ctx.stroke();
      ctx.restore();
      // logo top-right circle
      if (logo) drawLogo(ctx, logo, W - 150, 150, 130, accent);
      // bottom info left-aligned
      let y = H * 0.78;
      const tx = 70;
      if (shopName) { ctx.fillStyle = accent; ctx.font = 'bold 40px Arial, sans-serif'; ctx.fillText(shopName.toUpperCase(), tx, y); y += 30; }
      ctx.fillStyle = '#fff'; ctx.font = 'bold 82px Arial, sans-serif';
      ctx.save(); ctx.shadowColor = accent; ctx.shadowBlur = 24;
      for (const ln of wrapText(ctx, title, W - 140).slice(0, 2)) { y += 76; ctx.fillText(ln, tx, y); }
      ctx.restore();
      // accent underline
      y += 34; ctx.fillStyle = accent; ctx.fillRect(tx, y - 40, 160, 10); y += 30;
      ctx.fillStyle = '#e6e6ea'; ctx.font = 'bold 46px Arial, sans-serif';
      if (dateStr) { ctx.fillText(dateStr, tx, y); y += 62; }
      ctx.fillStyle = '#b9b9c0'; ctx.font = '44px Arial, sans-serif';
      if (salle) ctx.fillText(salle, tx, y);
    }

    const blob = await new Promise((res) => canvas.toBlob(res, 'image/jpeg', 0.92));
    return { url: URL.createObjectURL(blob), blob };
  };

  const generateAll = async () => {
    setGenerating(true);
    setVariants([]);
    setSelected(0);
    try {
      const cover = await loadImg(t.cover_image_url || t.banner_url);
      const logo = await loadImg(user?.logo_url || t.organizer?.logo_url || t.shop_logo_url || t.logo_url);
      const out = [];
      for (const L of LAYOUTS) {
        const r = await renderLayout(L.id, cover, logo);
        out.push({ id: L.id, name: L.name, ...r });
      }
      setVariants(out);
    } catch (e) {
      toast.error("Erreur lors de la génération des visuels");
    } finally {
      setGenerating(false);
    }
  };

  const openStory = () => { setStoryOpen(true); generateAll(); };

  useEffect(() => () => { variants.forEach((v) => v.url && URL.revokeObjectURL(v.url)); }, [variants]);

  const current = variants[selected];

  const downloadStory = () => {
    if (!current) return;
    const a = document.createElement('a');
    a.href = current.url;
    a.download = `story_${current.id}_${(t.name || 'event').replace(/\s+/g, '_')}.jpg`;
    document.body.appendChild(a); a.click(); a.remove();
    toast.success('Visuel téléchargé — ouvrez Instagram → Story → sélectionnez l\'image');
  };

  const nativeShare = async () => {
    if (!current) return;
    const file = new File([current.blob], 'story.jpg', { type: 'image/jpeg' });
    if (navigator.canShare && navigator.canShare({ files: [file] })) {
      try { await navigator.share({ files: [file], text: shareText }); } catch { /* cancelled */ }
    } else { downloadStory(); }
  };

  return (
    <>
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <Button variant="ghost" size={iconOnly ? 'icon' : 'sm'} className={triggerClassName || 'text-[#888] hover:text-[#4ECDC4] hover:bg-[#4ECDC4]/10 h-8 w-8'} title="Partager" data-testid={`share-${t.id}`}>
            <Share2 className="w-4 h-4" />{!iconOnly && <span className="ml-1 text-xs">Partager</span>}
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end" className="bg-[#1a1a1a] border-[#333] w-52">
          <DropdownMenuItem onClick={() => { navigator.clipboard.writeText(shareUrl); toast.success('Lien copié !'); }} className="cursor-pointer focus:bg-[#252525] text-white text-sm flex items-center gap-2" data-testid={`share-copy-${t.id}`}>
            <Link2 className="w-4 h-4 text-[#4ECDC4]" />Copier le lien
          </DropdownMenuItem>
          <DropdownMenuItem asChild className="cursor-pointer focus:bg-[#252525]">
            <a href={`https://wa.me/?text=${encodeURIComponent(shareText)}`} target="_blank" rel="noopener noreferrer" className="flex items-center gap-2" data-testid={`share-wa-${t.id}`}>{brandSvg.whatsapp}<span className="text-white text-sm">WhatsApp</span></a>
          </DropdownMenuItem>
          <DropdownMenuItem asChild className="cursor-pointer focus:bg-[#252525]">
            <a href={`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(shareUrl)}`} target="_blank" rel="noopener noreferrer" className="flex items-center gap-2" data-testid={`share-fb-${t.id}`}>{brandSvg.facebook}<span className="text-white text-sm">Facebook</span></a>
          </DropdownMenuItem>
          <DropdownMenuItem onClick={() => { navigator.clipboard.writeText(shareText); toast.success('Texte + lien copiés pour Discord !'); }} className="cursor-pointer focus:bg-[#252525] flex items-center gap-2" data-testid={`share-discord-${t.id}`}>{brandSvg.discord}<span className="text-white text-sm">Discord (copier)</span></DropdownMenuItem>
          <DropdownMenuItem onClick={openStory} className="cursor-pointer focus:bg-[#252525] flex items-center gap-2" data-testid={`share-ig-${t.id}`}>
            <Instagram className="w-4 h-4 text-[#E4405F]" /><span className="text-white text-sm">Story Instagram</span>
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>

      <Dialog open={storyOpen} onOpenChange={(o) => setStoryOpen(o)}>
        <DialogContent className="bg-[#1a1a1a] border-[#333] text-white max-w-md" data-testid="ig-story-dialog">
          <DialogHeader>
            <DialogTitle className="flex items-center gap-2"><Instagram className="w-5 h-5 text-[#E4405F]" />Story Instagram</DialogTitle>
            <DialogDescription className="text-[#888] text-xs">Choisissez un design (1080×1920), puis téléchargez-le et postez-le en Story.</DialogDescription>
          </DialogHeader>

          {generating ? (
            <div className="h-80 flex flex-col items-center justify-center gap-3">
              <Loader2 className="w-7 h-7 animate-spin text-[#FF6B35]" />
              <span className="text-xs text-[#888]">Génération des 5 designs…</span>
            </div>
          ) : variants.length > 0 ? (
            <div className="flex flex-col gap-4">
              {/* Big preview */}
              <div className="flex justify-center">
                <img src={current?.url} alt={current?.name} className="rounded-lg border border-[#333] max-h-[46vh] w-auto shadow-xl" data-testid="ig-story-preview" />
              </div>
              {/* Thumbnails selector */}
              <div className="grid grid-cols-5 gap-2" data-testid="ig-story-layouts">
                {variants.map((v, i) => (
                  <button
                    key={v.id}
                    onClick={() => setSelected(i)}
                    className={`relative rounded-md overflow-hidden border-2 transition-all ${selected === i ? 'border-[#FF6B35] scale-105' : 'border-[#333] opacity-70 hover:opacity-100'}`}
                    data-testid={`ig-layout-${v.id}`}
                    title={v.name}
                  >
                    <img src={v.url} alt={v.name} className="w-full h-auto block" />
                    <span className="absolute bottom-0 inset-x-0 bg-black/70 text-[9px] py-0.5 text-center text-white">{v.name}</span>
                  </button>
                ))}
              </div>
              {/* Actions */}
              <div className="flex flex-col gap-2">
                {typeof navigator !== 'undefined' && navigator.canShare && (
                  <Button onClick={nativeShare} className="bg-[#FF6B35] hover:bg-[#E55A25] gap-2 w-full" data-testid="ig-story-share">
                    <Share2 className="w-4 h-4" />Partager
                  </Button>
                )}
                <Button onClick={downloadStory} variant="outline" className="border-[#333] text-white gap-2 w-full" data-testid="ig-story-download">
                  <Download className="w-4 h-4" />Télécharger « {current?.name} »
                </Button>
                <Button onClick={() => { navigator.clipboard.writeText(shareText); toast.success('Texte copié !'); }} variant="ghost" className="text-[#888] gap-2 w-full" data-testid="ig-story-copytext">
                  <Copy className="w-4 h-4" />Copier le texte
                </Button>
              </div>
            </div>
          ) : (
            <div className="h-40 flex items-center justify-center text-[#888] text-sm">Aucun visuel disponible.</div>
          )}
        </DialogContent>
      </Dialog>
    </>
  );
}
